export enum MenuActions {
  Add = 'add',
  Remove = 'remove',
  Edit = 'edit',
}
